<template>
    <ClientOnly>
        <ExperienceSort />
        <template #fallback>
            <SectionActionSkeleton />
        </template>
    </ClientOnly>
    <ClientOnly>
        <ExperienceAdd />
        <template #fallback>
            <SectionActionSkeleton />
        </template>
    </ClientOnly>
</template>

<script setup lang="ts">
    import SectionActionSkeleton from '~/components/section/SectionActionSkeleton.vue';
    import ExperienceAdd from './ExperienceAdd.vue';
    import ExperienceSort from './ExperienceSort.vue';
</script>
